import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Callout } from '@folio/stripes-components';
import { useOkapiKy, withStripes } from '@folio/stripes-core';
import ImportTranslationsForm from './ImportTranslationsForm';

function ImportTranslationsManager(props) {
  const okapiKy = useOkapiKy();
  const [calloutRef, setCalloutRef] = useState(null);

  const showCallout = (message, type = 'success') => {
    if (calloutRef) calloutRef.sendCallout({ message, type });
  };

  const onFormSubmit = async (values) => {
    const { localeValue, categoryValue, importedTranslations,
      conflictStrategy = 'overwrite', isSourceImport = false } = values;

    if (!localeValue || !categoryValue
        || !importedTranslations
        || Object.keys(importedTranslations).length === 0) {
      showCallout(
        <FormattedMessage
          id="ui-translations.import.error.missingFields"
          defaultMessage="Please fill all required fields and select a file"
        />,
        'error'
      );
      return;
    }

    try {
      const result = await okapiKy.post('translation-keys/import', {
        json: {
          localeValue,
          categoryName: categoryValue,
          conflictStrategy,
          isSourceImport,
          entries: importedTranslations,
        },
      }).json();

      showCallout(
        <FormattedMessage
          id="ui-translations.import.success"
          defaultMessage="Import completed: {imported} imported, {skipped} skipped, {errors} errors"
          values={{
            imported: result.imported,
            skipped: result.skipped,
            errors: result.errors,
          }}
        />,
        result.errors > 0 ? 'warning' : 'success'
      );
    } catch (e) {
      showCallout(
        <FormattedMessage
          id="ui-translations.import.error.failed"
          defaultMessage="Import failed: {error}"
          values={{ error: e.message }}
        />,
        'error'
      );
    }
  };

  return (
    <>
      <ImportTranslationsForm
        {...props}
        onSubmit={onFormSubmit}
        initialValues={{
          localeValue: '',
          categoryValue: '',
          conflictStrategy: 'overwrite',
          isSourceImport: false,
          importedTranslations: {},
        }}
      />
      <Callout ref={setCalloutRef} />
    </>
  );
}

ImportTranslationsManager.propTypes = {
  stripes: PropTypes.object,
};

export default withStripes(ImportTranslationsManager);
